<template>
  <div class="voice-wrap">
    <transition-group name="fade">
      <div v-show="canPlayVoice" key="tag">
        <div class="voice-tag" @click.stop="toggleVoicePlay" v-if="times">
          <div class="play-status">
            <i v-if="playStatus === 'isPausing'" class="icon-play" />
            <i v-if="playStatus === 'isLoading'" class="el-icon-loading" />
            <i v-if="playStatus === 'isPlaying'" class="icon-pause" />
          </div>
          <div :class="['voice-wavy-line', playStatus === 'isPlaying' ? 'playing' : '']">
            <span v-for="index in 9" :key="index" :class="'voice-line-' + index"></span>
          </div>
          <div class="play-times">
            {{ currentTime }}''
          </div>
        </div>
        <audio style="display: none" :class="selector" :src="voiceUrl" preload="preload" />
      </div>
      <div v-show="!canPlayVoice" key="holder" class="audio-loading">
        <img src="~@/assets/images//audio-loading.gif" alt="">
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    uuid: String,
    times: Number,
    voiceUrl: String,
    skill: Number
  },
  computed: {
    ...mapGetters(['isPlayingVoice'])
  },
  watch: {
    isPlayingVoice(obj) {
      if (!this.voiceDom || !obj) return

      const { uuid, url, selector } = obj

      if (uuid === this.uuid && url === this.voiceUrl && selector === this.selector) {
        this.setVoiceStatus()
      } else {
        this.stopVoice()
      }
    },
    voiceUrl() {
      this.setVoiceDom()
    },
    times(newVal) {
      this.currentTime = newVal
    }
  },
  data() {
    return {
      voiceProgress: 0,
      playStatus: 'isPausing',
      timer: null,
      voiceDom: null,
      selector: null,
      currentTime: 0,
      canPlayVoice: false
    }
  },
  created() {
    this.currentTime = this.times
  },
  mounted() {
    this.setVoiceDom()
  },
  methods: {
    setVoiceDom() {
      let selector = (this.voiceUrl || '').replace(/\W/g, '')
      if (selector) {
        this.selector = selector + Math.random().toString(16).slice(2)
        this.$nextTick(() => {
          this.voiceDom = document.querySelector('.' + this.selector)
          this.voiceDom.addEventListener('playing', this.playVoice.bind(this))
          this.voiceDom.addEventListener('ended', this.stopVoice.bind(this))
          this.audioLoaded()
          // this.voiceDom.addEventListener('canplay', this.audioLoaded.bind(this))
        })
      }
    },
    setVoiceStatus() {
      if (!this.voiceDom) return
      const { times } = this
      if (times > 0) {
        this.playStatus = 'isLoading'
        this.voiceDom.play()
        // if (this.voiceDom.readyState) {
        //   this.playVoice()
        // } else {
        //   this.voiceDom.addEventListener('canplay', this.playVoice.bind(this))
        // }
      }
    },
    playVoice() {
      const { voiceDom, times } = this

      this.playStatus = 'isPlaying'

      this.timer = setInterval(async () => {
        if (voiceDom.ended) {
          this.stopVoice()
          await this.$store.dispatch('master/playSkillVoice', null)
        } else {
          const currentTime = Math.ceil(voiceDom.currentTime)
          this.currentTime = Math.max(times - currentTime, 0)
        }
      }, 1000)
    },
    async toggleVoicePlay() {
      if (this.timer) {
        this.stopVoice()
      } else {
        this.$store.dispatch('master/playSkillVoice', {
          url: this.voiceUrl,
          uuid: this.uuid,
          selector: this.selector
        })
      }
    },
    stopVoice() {
      clearInterval(this.timer)
      this.playStatus = 'isPausing'
      this.currentTime = this.times
      this.timer = null
      this.voiceDom.pause()
      this.voiceDom.currentTime = 0
      this.voiceDom.removeEventListener('canplay', this.playVoice)
    },
    audioLoaded() {
      const delay = Math.floor(Math.random() * 500 + 1500)
      setTimeout(() => {
        this.canPlayVoice = true
      }, delay)
    }
  }
}
</script>

<style lang="scss" scoped>
  $main-theme: #586884;

  @keyframes playing-line-1 {
    0%, 100% {
      transform: scaleY(0.33);
      opacity: 0.7;
    }

    25%, 75% {
      transform: scaleY(0.66);
      opacity: 0.9;
    }

    50% {
      transform: scaleY(1);
      opacity: 1;
    }
  }

  @keyframes playing-line-2 {
    0%, 50%, 100% {
      transform: scaleY(0.66);
      opacity: 0.9;
    }

    25% {
      transform: scaleY(1);
      opacity: 1;
    }

    75% {
      transform: scaleY(0.33);
      opacity: 0.7;
    }
  }

  @keyframes playing-line-3 {
    0%, 100% {
      transform: scaleY(1);
      opacity: 1;
    }

    25%, 75% {
      transform: scaleY(0.66);
      opacity: 0.9;
    }

    50% {
      transform: scaleY(0.33);
      opacity: 0.7;
    }
  }

  .voice-wrap {
    position: relative;
    width: 108px;
    height: 34px;
  }

  .voice-tag {
    @include flex(space-between);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 6px 10px;
    background: url('~@/assets/images/audio-bg.png') no-repeat center center;
    background-size: contain;
    overflow: hidden;
    transform: translateY(-1px);
    cursor: pointer;

    .play-times {
      width: 15px;
      height: 17px;
      color: $main-theme;
      font-size: 12px;
      line-height: 20px;
      font-weight: 500;
      margin-right: 7px;
    }
    .play-status {
      @include flex();
      width: 22px;
      height: 22px;
      flex-shrink: 0;

      i {
        display: block;
        border-radius: 100%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 22px;
        font-size: 20px;
        color: white;

        &.icon-play {
          width: 100%;
          height: 100%;
          background-image: url('~@/assets/images/audio-play.png')
        }

        &.icon-pause {
          width: 100%;
          height: 100%;
          background-image: url('~@/assets/images/audio-pause.png')
        }
      }
    }

    .voice-wavy-line {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 18px;
      margin: 0 5px;

      &.playing {
        span.voice-line-1 {
          animation: playing-line-1 0.8s infinite;
        }

        span.voice-line-2 {
          animation: playing-line-2 0.8s 0.1s infinite;
        }

        span.voice-line-3 {
          animation: playing-line-3 0.8s 0.2s infinite;
        }

        span.voice-line-4 {
          animation: playing-line-2 0.8s 0.3s infinite;
        }

        span.voice-line-5 {
          animation: playing-line-1 0.8s 0.4s infinite;
        }

        span.voice-line-6 {
          animation: playing-line-2 0.8s 0.5s infinite;
        }

        span.voice-line-7 {
          animation: playing-line-3 0.8s 0.6s infinite;
        }

        span.voice-line-8 {
          animation: playing-line-2 0.8s 0.7s infinite;
        }

        span.voice-line-9 {
          animation: playing-line-1 0.8s 0.8s infinite;
        }
      }
    }

    span {
      width: 2px;
      height: 16px;
      margin: 0 1px;
      background: $main-theme;
      border-radius: 2px;

      &.voice-line-1,
      &.voice-line-5,
      &.voice-line-9 {
        transform: scaleY(0.33);
        opacity: 0.7;
      }

      &.voice-line-2,
      &.voice-line-4,
      &.voice-line-6,
      &.voice-line-8 {
        transform: scaleY(0.66);
        opacity: 0.9;
      }
    }
  }

  .audio-loading {
    position: absolute;
    left: 0;
    top: 0;
    width: auto;
    height: 26px;
    img {
      width: auto;
      height: 100%;
    }
  }
</style>